module.exports = __webpack_public_path__ + "img/kid_studying.99955650.svg";